export const doa_tabs = [
  { id: 'overview', label: 'Overview', count: null },
  { id: 'live_decisions', label: 'Live decisions', count: null },
  { id: 'approval_matrix', label: 'Approval matrix', count: 6 },
  { id: 'financial_thresholds', label: 'Financial thresholds', count: 14 },
  { id: 'procurement_contracts', label: 'Procurement & contracts', count: null },
  { id: 'risk_routing', label: 'Risk-based routing', count: null },
  { id: 'delegations', label: 'Delegations', count: 1 },
  { id: 'sod', label: 'Segregation of duties', count: 3 },
  { id: 'exception_log', label: 'Exception log', count: 2 }
];

export const summary_cards = [
  {
    label: 'Authority rules',
    value: '30',
    note: 'Matrix, thresholds, mandates',
    accent: 'amber'
  },
  {
    label: 'Active delegations',
    value: '1',
    note: 'Temporary hand-overs',
    accent: 'red',
    tab_id: 'delegations'
  },
  {
    label: 'SOD conflicts',
    value: '3',
    note: 'Request/approve/pay overlap',
    accent: 'red',
    tab_id: 'sod'
  },
  {
    label: 'Open exceptions',
    value: '2',
    note: 'Approvals outside authority',
    accent: 'amber',
    tab_id: 'exception_log'
  }
];

export const authority_fields = [
  {
    label: 'Category',
    type: 'select',
    value: 'Procurement / PO',
    options: ['General expenditure', 'Capital expenditure', 'Procurement / PO', 'Contract value']
  },
  {
    label: 'Amount (R)',
    type: 'input',
    value: '750000',
    placeholder: 'Enter amount'
  },
  {
    label: 'Risk level',
    type: 'select',
    value: 'High',
    options: ['Low', 'Medium', 'High']
  },
  {
    label: 'Scenario',
    type: 'select',
    value: 'None',
    options: ['None', 'High-risk supplier', 'High-value contract (> R 5m)', 'Personal data sharing', 'Procurement deviation']
  },
  {
    label: 'Requested by (optional)',
    type: 'input',
    value: '',
    placeholder: 'e.g. CFO'
  }
];

export const approval_rows = [
  {
    transaction: 'Operational expenditure',
    category: 'General expenditure',
    dept: 'All',
    band: 'R 50 000 - R 500 000',
    risk: 'Low',
    risk_class: 'bg-success-subtle text-success-emphasis',
    approval: 'Executive (CFO)',
    edit_note: 'Single approver within band',
    edit_second_approver: 'Optional'
  },
  {
    transaction: 'Operational expenditure',
    category: 'General expenditure',
    dept: 'All',
    band: 'Above R 500 000',
    risk: 'Medium',
    risk_class: 'bg-warning-subtle text-warning-emphasis',
    approval: 'CEO + CFO',
    edit_note: 'Dual sign-off',
    edit_second_approver: 'CFO'
  },
  {
    transaction: 'Capital expenditure',
    category: 'Capital expenditure',
    dept: 'All',
    band: 'Above R 1 000 000',
    risk: 'High',
    risk_class: 'bg-danger-subtle text-danger-emphasis',
    approval: 'Board',
    edit_note: 'Board resolution + risk routing',
    edit_second_approver: 'Optional'
  },
  {
    transaction: 'Purchase order',
    category: 'Procurement / PO',
    dept: 'Procurement',
    band: 'R 30 000 - R 500 000',
    risk: 'Low',
    risk_class: 'bg-success-subtle text-success-emphasis',
    approval: 'SCM Manager',
    edit_note: '3 quotes required',
    edit_second_approver: 'Optional'
  },
  {
    transaction: 'Contract award',
    category: 'Contract value',
    dept: 'All',
    band: 'Above R 500 000',
    risk: 'Medium',
    risk_class: 'bg-warning-subtle text-warning-emphasis',
    approval: 'CFO + CEO',
    edit_note: 'Tender committee recommendation',
    edit_second_approver: 'CEO'
  },
  {
    transaction: 'Data sharing agreement',
    category: 'General expenditure',
    dept: 'Legal',
    band: 'Any personal data',
    risk: 'High',
    risk_class: 'bg-danger-subtle text-danger-emphasis',
    approval: 'Information Officer + Legal',
    edit_note: 'POPIA - risk routing applies',
    edit_second_approver: 'Legal'
  }
];

export const financial_threshold_groups = [
  {
    label: 'General expenditure',
    cards: [
      { band: 'R 0 - R 50 000', approver: 'Line manager' },
      { band: 'R 50 000 - R 500 000', approver: 'Executive (CFO)' },
      { band: 'R 500 000 - R 5 000 000', approver: 'CEO + CFO' },
      { band: 'Above R 5 000 000', approver: 'Board' }
    ]
  },
  {
    label: 'Capital expenditure',
    cards: [
      { band: 'R 0 - R 250 000', approver: 'Executive (CFO)' },
      { band: 'R 250 000 - R 1 000 000', approver: 'CFO + CEO' },
      { band: 'Above R 1 000 000', approver: 'Board' }
    ]
  },
  {
    label: 'Procurement / PO',
    cards: [
      { band: 'R 0 - R 30 000', approver: 'SCM officer' },
      { band: 'R 30 000 - R 500 000', approver: 'SCM Manager' },
      { band: 'R 500 000 - R 5 000 000', approver: 'CFO' },
      { band: 'Above R 5 000 000', approver: 'Board' }
    ]
  },
  {
    label: 'Contract value',
    cards: [
      { band: 'R 0 - R 500 000', approver: 'CFO' },
      { band: 'R 500 000 - R 5 000 000', approver: 'CFO + CEO' },
      { band: 'Above R 5 000 000', approver: 'Board' }
    ]
  }
];

export const procurement_authority_groups = [
  {
    title: 'Procurement authority',
    modal_key: 'procurement_authority',
    description: 'Who can approve supplier registration, purchase orders, deviations, emergency procurement and contract awards.',
    rows: [
      { action: 'Supplier registration', condition: 'Standard-risk supplier', approver: 'SCM Manager', evidence: 'CSD + tax + BBBEE' },
      { action: 'Supplier registration', condition: 'High-risk supplier', approver: 'SCM Manager + Compliance', evidence: 'Enhanced due diligence' },
      { action: 'Purchase order', condition: 'R 30k - R 500k', approver: 'SCM Manager', evidence: '3 quotes / RFQ pack' },
      { action: 'Deviation from procurement process', condition: 'Any value', approver: 'CFO', evidence: 'Deviation memo + reason' },
      { action: 'Emergency procurement', condition: 'Business continuity threat', approver: 'CFO (ratified by EXCO)', evidence: 'Emergency justification' },
      { action: 'Contract award', condition: 'Above R 500k', approver: 'CFO + CEO', evidence: 'Tender committee minutes' }
    ]
  },
  {
    title: 'Contract authority',
    modal_key: 'contract_authority',
    description: 'Who can approve contract terms, renewals, amendments and cancellations.',
    rows: [
      { action: 'New contract terms', condition: 'Above R 500k', approver: 'Legal + CFO', evidence: 'Legal review + DoA log' },
      { action: 'Renewal', condition: 'Within original value', approver: 'Contract owner + CFO', evidence: 'Performance review' },
      { action: 'Amendment / variation', condition: 'Value increase > 15%', approver: 'CFO (Board if > R 5m)', evidence: 'Variation justification' },
      { action: 'Cancellation / termination', condition: 'Any active contract', approver: 'Legal + EXCO', evidence: 'Termination memo + risk assessment' }
    ]
  }
];

export const risk_routing_rows = [
  { trigger: 'Any high-risk transaction', risk: 'High', adds: ['Compliance', 'Internal Audit'], rationale: 'Enhanced oversight on any elevated-risk decision', status: 'Active' },
  { trigger: 'High-risk supplier', risk: 'High', adds: ['Compliance', 'Internal Audit'], rationale: 'Enhanced due diligence on elevated supplier risk', status: 'Active' },
  { trigger: 'High-value contract (> R 5m)', risk: 'High', adds: ['Legal', 'Board'], rationale: 'Material commitment requires board oversight', status: 'Active' },
  { trigger: 'Personal data sharing', risk: 'High', adds: ['Legal', 'Information Officer'], rationale: 'POPIA lawful-processing assurance', status: 'Active' },
  { trigger: 'Procurement deviation', risk: 'Medium', adds: ['Compliance'], rationale: 'Deviation from competitive process', status: 'Active' }
];

export const delegations_table_rows = [
  { delegator: 'M. Khan (CFO)', authority: 'Executive (CFO)', delegate: 'T. Mahlangu (Finance Director)', scope: 'Up to R 1 000 000', period: '12 May 2026 ? 26 May 2026', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
  { delegator: 'P. Naidoo (CEO)', authority: 'CEO', delegate: 'M. Khan (CFO)', scope: 'Operational only, excl. board-reserved', period: '01 Jun 2026 ? 10 Jun 2026', status: { label: 'Scheduled', class: 'bg-info-subtle text-info-emphasis' } },
  { delegator: 'R. Govender (CISO)', authority: 'IT Security (privileged)', delegate: 'K. Pillay (Security Lead)', scope: 'Access approvals only', period: '20 Apr 2026 ? 30 Apr 2026', status: { label: 'Expired', class: 'bg-danger-subtle text-danger-emphasis' } }
];

export const sod_rule_cards = [
  { title: 'Procure-to-pay', chips: ['Request (REQ)', 'Approve (PO)', 'Pay (release)'], note: 'All three must be different people', status: 'In force' },
  { title: 'Supplier onboarding', chips: ['Capture supplier', 'Verify documents', 'Activate'], note: 'Capturer cannot verify or activate', status: 'In force' },
  { title: 'Payroll', chips: ['Add employee', 'Approve salary', 'Release payment'], note: 'Maker-checker on all changes', status: 'In force' }
];

export const sod_conflict_rows = [
  { person: 'Employee A - Procurement', process: 'Procure-to-pay', conflict: 'Requested REQ-211 and approved its PO', severity: 'High', severity_class: 'bg-danger-subtle text-danger-emphasis', status: { label: 'Escalated', class: 'bg-danger-subtle text-danger-emphasis' } },
  { person: 'Employee B - Finance', process: 'Procure-to-pay', conflict: 'Approved PO and released payment on INV-2219', severity: 'High', severity_class: 'bg-danger-subtle text-danger-emphasis', status: { label: 'Logged', class: 'bg-warning-subtle text-warning-emphasis' } },
  { person: 'Employee C - SCM', process: 'Supplier onboarding', conflict: 'Captured and activated BlueData Services', severity: 'Medium', severity_class: 'bg-warning-subtle text-warning-emphasis', status: { label: 'Monitoring', class: 'bg-info-subtle text-info-emphasis' } }
];

export const financial_threshold_edit_catalog = {
  'General expenditure': {
    category: 'General expenditure',
    band_to_limits: {
      'R 0 - R 50 000': { from: '0', to: '50000', approver: 'Line manager', second: 'Optional' },
      'R 50 000 - R 500 000': { from: '50000', to: '500000', approver: 'Executive (CFO)', second: 'Optional' },
      'R 500 000 - R 5 000 000': { from: '500000', to: '5000000', approver: 'CEO + CFO', second: 'CFO' },
      'Above R 5 000 000': { from: '5000000', to: '', approver: 'Board', second: 'Optional' }
    }
  },
  'Capital expenditure': {
    category: 'Capital expenditure',
    band_to_limits: {
      'R 0 - R 250 000': { from: '0', to: '250000', approver: 'Executive (CFO)', second: 'Optional' },
      'R 250 000 - R 1 000 000': { from: '250000', to: '1000000', approver: 'CFO + CEO', second: 'CEO' },
      'Above R 1 000 000': { from: '1000000', to: '', approver: 'Board', second: 'Optional' }
    }
  },
  'Procurement / PO': {
    category: 'Procurement / PO',
    band_to_limits: {
      'R 0 - R 30 000': { from: '0', to: '30000', approver: 'SCM officer', second: 'Optional' },
      'R 30 000 - R 500 000': { from: '30000', to: '500000', approver: 'SCM Manager', second: 'Optional' },
      'R 500 000 - R 5 000 000': { from: '500000', to: '5000000', approver: 'CFO', second: 'Optional' },
      'Above R 5 000 000': { from: '5000000', to: '', approver: 'Board', second: 'Optional' }
    }
  },
  'Contract value': {
    category: 'Contract value',
    band_to_limits: {
      'R 0 - R 500 000': { from: '0', to: '500000', approver: 'CFO', second: 'Optional' },
      'R 500 000 - R 5 000 000': { from: '500000', to: '5000000', approver: 'CFO + CEO', second: 'CEO' },
      'Above R 5 000 000': { from: '5000000', to: '', approver: 'Board', second: 'Optional' }
    }
  }
};


